import { useState, useEffect, useCallback } from 'react';
import { DefaultSizeMap, getBreakPoint } from './const';
import { isServer } from 'shared/constants/isServer';
import { MediaBreakpointName, MediaQueryPropsForCard } from './const';

type MediaQueryReturn<T extends MediaQueryPropsForCard> = {
    breakPoint: MediaBreakpointName<T>
    breakpointValue?: number
    breakpointSize: number
    width: number
    height: number
}

export enum NewBreakpoints {
    MOBILE = 'mobile',
    TABLET = 'tablet',
    LAPTOP = 'laptop',
    DESKTOP = 'desktop'
}


/**
 * кастомный хук следящий за брейкпоинтами ресайза и отдающий одно из 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xsm'.
 * Дефолтные брейкпоинты { xxl: '1440px', xl: '1200px', lg: '992px', md: '743px', sm: '576px' } могут быть заменены на пользовательские.
 * Для актуальных брейкпоинтов необходимо передать в props свойство newBreakpoints
 */

export function useMediaQuoryForCard<T extends MediaQueryPropsForCard>(props?: T): MediaQueryReturn<T> {
    const initBreakPoint = getBreakPoint(props)
    const [breakPoint, setBreakPoint] = useState<typeof initBreakPoint>(initBreakPoint);
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const resizeCallback = useCallback(() => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
        const newBreakPoint = getBreakPoint(props)
        setBreakPoint(newBreakPoint);
    }, [props])

    useEffect(() => {
        resizeCallback()
    }, [props, resizeCallback])
    
    useEffect(() => {
        if (isServer) {
            return
        }
        window.addEventListener('resize', resizeCallback);
        return () => {
            if (isServer) {
                return
            }
            window.removeEventListener('resize', resizeCallback)
        };
    }, []);

    //@ts-ignore
    const breakpointSize = DefaultSizeMap[breakPoint.replace('lg', 'l')]
    const breakpointValue = breakpointSize ? parseInt(breakpointSize) : undefined

    return { 
        breakPoint: breakPoint as MediaBreakpointName<T>, 
        breakpointValue,
        breakpointSize,
        width,
        height
    };
}import { useState, useEffect, useCallback } from 'react';
import { DefaultSizeMap, getBreakPoint } from './const';
import { isServer } from 'shared/constants/isServer';
import { MediaBreakpointName, MediaQueryPropsForCard } from './const';

type MediaQueryReturn<T extends MediaQueryPropsForCard> = {
    breakPoint: MediaBreakpointName<T>
    breakpointValue?: number
    breakpointSize: number
    width: number
    height: number
}

export enum NewBreakpoints {
    MOBILE = 'mobile',
    TABLET = 'tablet',
    LAPTOP = 'laptop',
    DESKTOP = 'desktop'
}


/**
 * кастомный хук следящий за брейкпоинтами ресайза и отдающий одно из 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xsm'.
 * Дефолтные брейкпоинты { xxl: '1440px', xl: '1200px', lg: '992px', md: '743px', sm: '576px' } могут быть заменены на пользовательские.
 * Для актуальных брейкпоинтов необходимо передать в props свойство newBreakpoints
 */

export function useMediaQuoryForCard<T extends MediaQueryPropsForCard>(props?: T): MediaQueryReturn<T> {
    const initBreakPoint = getBreakPoint(props)
    const [breakPoint, setBreakPoint] = useState<typeof initBreakPoint>(initBreakPoint);
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const resizeCallback = useCallback(() => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
        const newBreakPoint = getBreakPoint(props)
        setBreakPoint(newBreakPoint);
    }, [props])

    useEffect(() => {
        resizeCallback()
    }, [props, resizeCallback])
    
    useEffect(() => {
        if (isServer) {
            return
        }
        window.addEventListener('resize', resizeCallback);
        return () => {
            if (isServer) {
                return
            }
            window.removeEventListener('resize', resizeCallback)
        };
    }, []);

    //@ts-ignore
    const breakpointSize = DefaultSizeMap[breakPoint.replace('lg', 'l')]
    const breakpointValue = breakpointSize ? parseInt(breakpointSize) : undefined

    return { 
        breakPoint: breakPoint as MediaBreakpointName<T>, 
        breakpointValue,
        breakpointSize,
        width,
        height
    };
}